import script from "./AudioPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./AudioPlayer.vue?vue&type=style&index=0&id=00002d30&lang=scss"

const __exports__ = script;

export default __exports__